import React, {useEffect, useState} from 'react'
import {Card, CardContent, CardHeader, Divider, Link, TextField} from "@material-ui/core";
import axios from "axios";
import {Autocomplete} from "@material-ui/lab";
import {formatDateMDYWithoutTimeZone} from "../../../helpers/utils";

const RecentNews = ({
                        classes,
                        selectedInvestor,
                        selectedContact,
                        adminUserSession,
                        dataset,
                    }) => {
    const [contactNews, setContactNews] = useState([])
    const [investorNews, setInvestorNews] = useState([])
    const [investor, setInvestor] = useState()
    const [contact, setContact] = useState()

    useEffect(() => {
        if (investor?.id !== selectedInvestor[0]?.id) {
            fetchRecentNews({
                value: selectedInvestor[0],
                firm_type: dataset === 'RIA' ? 'RiaInvestor' : 'Investor'
            })
        }
    }, [selectedInvestor])

    useEffect(() => {
        if (contact?.id !== selectedContact[0]?.id) {
            fetchRecentNews({
                value: selectedContact[0],
                item_contact_type: dataset === 'RIA' ? 'RiaContact' : 'Contact'
            })
        }
    }, [selectedContact])

    const fetchRecentNews = ({
                                 value,
                                 firm_type,
                                 item_contact_type,
                             }) => {
        if (!!firm_type) {
            setInvestor(value)
        } else if (!!item_contact_type) {
            setContact(value)
        }
        if (!!value?.id) {
            const params = {
                firm_id: !!firm_type ? value.id : null,
                firm_type: firm_type,
                item_contact_id: !!item_contact_type ? value.id : null,
                item_contact_type: item_contact_type,
            }
            axios.get(
                '/v1/admin/news/recent_news',
                {
                    params: params,
                    headers: {
                        'X-Admin-User-Email': adminUserSession.email,
                        'X-Admin-User-Token': adminUserSession.token
                    }
                }
            ).then((response) => {
                const {news} = response.data
                if (!!firm_type) {
                    setInvestorNews(news)
                } else if (!!item_contact_type) {
                    setContactNews(news)
                }
            })
        }
    }

    const box = (name, news) => {
        return (
            <React.Fragment>
                {!!name ?
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <span style={{fontSize: '20px', padding: '20px 0'}}>{name}'s recent news: </span>
                        {!!news && news.length > 0 ?
                            <>{news.map(n =>
                                <>
                                    <div style={{display: 'flex', flexDirection: 'column', padding: '10px 0'}}>
                                        <Link href={n.source_url} target={'_blank'}>{n.title}</Link>
                                        <span style={{
                                            alignSelf: 'end',
                                            color: '#707070',
                                            fontStyle: 'italic',
                                            fontSize: '15px',
                                        }}>{formatDateMDYWithoutTimeZone(n.written_at)}</span>
                                    </div>
                                    <Divider/>
                                </>
                            )}</>
                            :
                            <span>No News</span>
                        }
                    </div>
                    : null
                }
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div style={{
                position: 'absolute',
                right: '1px',
                top: '1px',
                width: '24%',
                height: '100%',
            }}>
                <Card
                    className={classes.root}
                    style={{width: '100%', height: '100%'}}
                >
                    <CardHeader title='Recent News'/>
                    <Divider/>
                    <CardContent>
                        <div style={{display: 'flex'}}>
                            <Autocomplete
                                disablePortal
                                options={selectedInvestor}
                                renderInput={(params) => <TextField {...params} label="Investor"/>}
                                getOptionLabel={(option) => option?.name || ''}
                                style={{marginRight: '20px', width: '100%'}}
                                onChange={(event, value) => fetchRecentNews({
                                    value,
                                    firm_type: dataset === 'RIA' ? 'RiaInvestor' : 'Investor'
                                })}
                            />
                            <Autocomplete
                                disablePortal
                                options={selectedContact}
                                renderInput={(params) => <TextField {...params} label="Contact"/>}
                                getOptionLabel={(option) => option?.name || ''}
                                style={{width: '100%'}}
                                onChange={(event, value) => fetchRecentNews({
                                    value,
                                    item_contact_type: dataset === 'RIA' ? 'RiaContact' : 'Contact'
                                })}
                            />
                        </div>
                        {box(contact?.name, contactNews)}
                        {box(investor?.name, investorNews)}
                    </CardContent>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default RecentNews